module.exports = __webpack_public_path__ + "img/shot_tx19112003.b707d133.jpg";